import useSWR from 'swr'
import { authCall } from '.'
import { activities } from './endpoints'
import { IActivityList } from '../interfaces/activity'

const ActivityService = {
  useGetActivityList: ({ page = 1, size = 15, name = '' }) => {
    const url = `${activities}?page=${page}&limit=${size}&name=${name}`

    return useSWR(url, () => {
      return authCall<IActivityList>({
        url,
        method: 'get',
      })
    })
  },
}

export default ActivityService
